import { Directive, HostBinding, inject } from "@angular/core";
import { MatAccordion } from "@angular/material/expansion";

@Directive({
  selector: "mat-accordion[appTableAccordion]",
  standalone: true
})
export class TableAccordionDirective {
  private _accordion: MatAccordion = inject(MatAccordion);

  // eslint-disable-next-line @tseslint/typedef
  @HostBinding("class")
  protected accordionClass = "table-accordion";

  constructor () {
    this.initConfiguration();
  }

  private initConfiguration (): void {
    this._accordion.displayMode = "flat";
    this._accordion.togglePosition = "before";
    this._accordion.multi = true;
  }
}
